import { hubsApi as generatedApi } from './generated/hubsApi';

const LIST_ID = 'LIST' as const;

/*
 * Number.POSITIVE_INFINITY is a very strong statement, which expects
 * that the hubs won't be changing, in case they will become editable
 * in the future, this part needs to be refactored.
 * */
const CATALOGUE_CACHE_FOREVER = Number.POSITIVE_INFINITY;

/**
 * Cache wiring for the hubs endpoints, kept out of `generated/hubsApi.ts` so `npm run api:generate`
 * cannot overwrite it. The `Hub` tag type is declared once on `baseApi`.
 *
 * Only the catalogue listing is wired up and exported. The generated api also carries `getHubById`,
 * `createHub` and `updateHub`, but this app only ever reads the catalogue to populate the transport
 * order form, so exposing hooks for them would be dead surface that also has to be kept in step with
 * the tag graph. They stay in the schema map, which is a compile-time completeness check, so adding
 * one back is a matter of wiring its tags and exporting its hook here.
 */
export const hubsApi = generatedApi.enhanceEndpoints({
    endpoints: {
        listHubs: {
            providesTags: [{ type: 'Hub', id: LIST_ID }],
            keepUnusedDataFor: CATALOGUE_CACHE_FOREVER,
        },
    },
});

export const { useListHubsQuery } = hubsApi;
